import { GetStaticProps, NextPage } from 'next'
import dynamic from 'next/dynamic'
import { PageResponse } from '@aether/models'
import {
  getAccountContent,
  getSiteConfiguration,
} from '@aether/services/sanity-service'
import { Container } from '@aether/components'
import { setTag } from '@sentry/nextjs'
import { ROUTE_BASE_ACCOUNT_HOME } from '@aether/configs'
import { getActiveDiscounts } from '@aether/discounts/data-access'
import { styled } from '@aether/styles'

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const DynamicHomePage = dynamic(
  () => import('@aether/account/feature').then((mod) => mod.HomePage),
  {
    ssr: false,
  },
)

const Placeholder = styled(Container, {
  minHeight: '530px',
})

const AccountHome: NextPage<PageResponse<[]>> = ({
  siteConfiguration: { colorsMap },
  account,
}) => {
  return (
    <Placeholder>
      <DynamicHomePage colorsMap={colorsMap} account={account} />
    </Placeholder>
  )
}

export const getStaticProps: GetStaticProps<PageResponse<[]>> = async ({
  locale,
  preview = false,
}) => {
  const siteConfiguration = await getSiteConfiguration(locale, preview)
  const accountContent = await getAccountContent(locale, preview)
  setTag('page_path', ROUTE_BASE_ACCOUNT_HOME)
  setTag('page_locale', locale)

  const discounts = await getActiveDiscounts()

  return {
    props: {
      pageBuilder: [],
      siteConfiguration,
      hideFooter: false,
      hideHeader: false,
      allDiscounts: discounts,
      account: accountContent,
    },
    revalidate: 300,
  }
}

export default AccountHome
